import { computed } from '@vue/composition-api'
import TennisServerIcon from 'base/icons/png/tennis-server.png'
import TableTennisServerIcon from 'base/icons/png/table-tennis-server.png'
import VolleyballServerIcon from 'base/icons/png/volleyball-server.png'
import BadmintonServerIcon from 'base/icons/png/badminton-server.png'

const visibleServerSportIdList = [
  'sr:sport:5', // tennis
  'sr:sport:20', // table tennis
  'sr:sport:23', // Volleyball
  'sr:sport:31' // Badminton
]

const sportIdToServerIconMap = {
  'sr:sport:5': TennisServerIcon, // tennis
  'sr:sport:20': TableTennisServerIcon, // table tennis
  'sr:sport:23': VolleyballServerIcon, // Volleyball
  'sr:sport:31': BadmintonServerIcon // Badminton
}

/**
 * @typedef {import('@vue/composition-api').Ref} Ref<T>
 * @template T
 */

/**
 * @typedef {'home' | 'away' | null} SportServer
 */

/**
 * @param {object} options
 * @param {Ref<string>} options.sportId
 * @param {Ref<SportServer>} options.server
 * @param {Ref<boolean>} options.isLive
 */
export const useSportServer = (options = {}) => {
  const { sportId, server, isLive } = options

  const serverIcon = computed(() => sportIdToServerIconMap[sportId.value])

  const isServerVisible = computed(() => {
    if (visibleServerSportIdList.includes(sportId.value)) {
      return isLive.value || server.value != null
    }

    return false
  })

  const isHomeServer = computed(() => server.value === 'home')
  const isAwayServer = computed(() => server.value === 'away')

  return {
    serverIcon,
    isServerVisible,
    isHomeServer,
    isAwayServer
  }
}
